export default class Header {
    /**
     * constructor a des variables
     * @param {this} element - contient un element html
     * @param {this} scrollLimit - contient une valeure minimum avant laquel le header n est pas cacher
     * @param {this} scrollPosition - contient la position du scroll actuel
     * @param {this} lastScrollPosition - contient la position du scroll avant son mouvement
     * @param {this} options - contient les options du header
     * 
     */
  constructor(element) {
    this.element = element;
    this.scrollLimit = 0.1;
    this.scrollPosition = 0;
    this.lastScrollPosition = 0;
    this.html = document.documentElement;
    this.init();
    this.initNavMobile();
    this.options = {
      valeurScroll: 0.1,
    };
  }

    /**
     * init gere le scroll sur la fenetre avec un event  
     */
  init() {
    this.setOptions();
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

    /**
     * setOptions gere les options offert pour empecher de cacher le header si besoin
     */
  setOptions() {
    this.scrollLimit = this.element.dataset.scrollLimit;

    if (!('noHiding' in this.element.dataset)) {
    } else {
      this.scrollLimit = 1;
    }
  }

    /**
     * onScroll recupere les positions de scroll et dirige les infos vers les methodes ci dessous
     * @param {type} name - description
     */
  onScroll(evt) {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;

    this.setHeaderState();
    this.setDirectionState();
  }

    /**
     * setHeaderState recoit les infos de scroll et ajoute la classe d etat ou retire la classe d etat selon si le header doit etre cacher ou non
     */
  setHeaderState() {
    const scrollHeight = document.scrollingElement.scrollHeight;
    if (this.scrollPosition > scrollHeight * this.scrollLimit) {
      this.html.classList.add('header-is-hidden');
    } else {
      this.html.classList.remove('header-is-hidden');
    }
  }

    /**
     * setDirectionState recoit les infos de scroll et ajoute la classe d etat selon la direction de scroll sur la balise html
     * @param {type} name - description
     */
  setDirectionState() {
    if (this.scrollPosition > this.lastScrollPosition) {
      this.html.classList.add('is-scrolling-down');
      this.html.classList.remove('is-scrolling-up');
    } else {
      this.html.classList.add('is-scrolling-up');
      this.html.classList.remove('is-scrolling-down');
    }
  }

    /**
     * initNavMobile 
     * @param {const} toggle - ajoute la classe d etat sur le X qui ouvre et ferme le header en version mobile
     */
  initNavMobile() {
    const toggle = this.element.querySelector('.js-toggle');
    toggle.addEventListener('click', this.onToggleNav.bind(this));
  }

    /**
     * onToggleNav ajoute la classe d etat sur la balise html lorsque le header est actif ou fermer
     */
  onToggleNav() {
    this.html.classList.toggle('nav-is-active');
  }
}
